// modules
import { routerMiddleware as createRouterMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { createLogger } from 'redux-logger'
import thunkMiddleware from 'redux-thunk'

// store
import createRootReducer from 'src/store/modules'

const combineStoreAndHistory = (initialState: any, history: any) => {
  const loggerConfig = {
    collapsed: true
  }

  const routerMiddleware = createRouterMiddleware(history)

  const middlewares = [thunkMiddleware, routerMiddleware]
  const enhancer = composeWithDevTools({
    trace: true,
    traceLimit: 50
  })

  if (process.env.ENVIRONMENT_TYPE === 'dev') {
    const loggerMiddleware = createLogger(loggerConfig)

    middlewares.push(loggerMiddleware)
  }

  const store = createStore(
    createRootReducer(history),
    initialState,
    enhancer(applyMiddleware(...middlewares))
  )

  return store
}

const initialState = {}

export const history = createBrowserHistory()
export const store = combineStoreAndHistory(initialState, history)
